module.exports = __webpack_public_path__ + "img/traceless.3256e841.svg";